import { axiosInstance } from "./AxiosInstance";

export async function getADTRecords(patientId) {
  return axiosInstance
    .get(`api/PatientADT?patientId=${patientId}`)
    .then(function (response) {
      //debugger;
      return response;
    })
    .catch(function (error) {
      return error;
    });
}
